<fury-page-layout-header>
    <fury-container class="header">
        <div class="nav">
            <button (click)="toggleMenu()" class="menu-toggle" [class.open]="isMenuOpen" aria-controls="mobile-menu" aria-label="Menu weergeven" aria-expanded="false">
                <span class="bar top"></span>
                <span class="bar middle"></span>
                <span class="bar bottom"></span>
            </button>
            <a title="MilieuKlachtenCentrale" href="{{ environment.homepage_url }}" aria-current="page" class="brand">
                <img src="{{ environment.homepage_url }}/images/MKC.svg" loading="lazy" alt="MilieuKlachtenCentrale" class="brand-image">
            </a>
            <ul id="mobile-menu" class="nav-right" [class.open]="isMenuOpen" role="menubar" aria-hidden="true">
                <li role="none">
                    <a title="Actueel" class="nav-button w-inline-block white-bg" href="{{ environment.homepage_url }}/actueel" role="menuitem">
                        <div class="button-text-nav">Actueel</div>
                    </a>
                </li>
                <li role="none">
                    <a title="Ongewoon voorval" class="nav-button w-inline-block white-bg" href="{{ environment.homepage_url }}/ongewoon-voorval"
                       role="menuitem">
                        <div class="button-text-nav">Ongewoon voorval</div>
                    </a>
                </li>
                <li class="menu-item has-dropdown" role="none">
                    <button aria-haspopup="true" aria-expanded="false" class="nav-button w-inline-block white-bg dropdown-toggle" role="menuitem">
                        <div class="button-text-nav">Soorten overlast</div>
                        <mat-icon class="w-icon-dropdown-toggle" role="none">keyboard_arrow_down</mat-icon>
                    </button>
                    <ul class="dropdown-menu" role="menu" aria-label="Soorten overlast submenu">
                        <li role="none"><a class="nav-button w-inline-block white-bg" href="{{ environment.homepage_url }}/geur-overlast" role="menuitem">
                            <div class="button-text-nav">Geur</div>
                        </a></li>
                        <li role="none"><a class="nav-button w-inline-block white-bg" href="{{ environment.homepage_url }}/geluid-overlast" role="menuitem">
                            <div class="button-text-nav">Geluid</div>
                        </a></li>
                    </ul>
                </li>
                <li role="none">
                    <a title="Meldformulier milieuklachten" role="menuitem" href="https://meldformulier.milieuklachtencentrale.nl/klacht-overlast"
                       class="nav-button w-inline-block space-left">
                        <div class="button-text-nav">Meldformulier</div>
                        <mat-icon>arrow_circle_right</mat-icon>
                    </a>
                </li>
            </ul>
            <div class="nav-spacer"></div>
        </div>
    </fury-container>
</fury-page-layout-header>
<div class="menu-overlay" [class.open]="isMenuOpen"></div>
